<template>
  <Layout>
    <template #content>
      <div class="join_alone">
        <pageHead device="desktop" page="login" :title="$t('store.btn.user_login')" />

        <div class="join_alone-con">
          <div class="join_alone_bg">
            <div class="joinbg_li li_s1">
              <div class="nicon icon-point"></div>
              <p>{{ $t("store.footer02_title") }}</p>
            </div>
            <div class="joinbg_li li_s2">
              <div class="nicon icon-fast"></div>
              <p>{{ $t("store.footer03_title") }}</p>
            </div>
            <div class="joinbg_li li_s3">
              <div class="nicon icon-diamond"></div>
              <p>{{ $t("store.footer04_title") }}</p>
            </div>

            <div class="modal-main login">
              <div class="title">{{ $t("store.btn.user_login") }}</div>
              <b-form @submit.prevent="login">
                <div class="form-group">
                  <label for="userName">
                    {{ WebSetting.MasterAccount == "mobile" ? $t("store.user.phone_number") : $t("store.user.account") }}
                  </label>
                  <input
                    type="text"
                    v-model="form.account"
                    class="form-control"
                    id="userName"
                    required
                  />
                  <small id="emailHelp" class="form-text text-muted">
                    <i class="icon icon-infomation"></i>
                    {{ $t("store.user.id_group620") }}
                  </small>
                </div>

                <div class="form-group">
                  <label for="Password">{{ $t("store.pw.password") }}</label>
                  <input
                    id="Password"
                    class="form-control"
                    v-model="form.password"
                    :type="pwInputType"
                    autocomplete="off"
                    required
                  />
                  <div class="pw-toggle" @click="changeIcon"><i :class="pwIconData"></i></div>

                  <small id="emailHelp" class="form-text text-muted">
                    <i class="icon icon-infomation"></i>
                    {{ $t("store.user.id_group620") }}
                  </small>
                </div>

                <div v-if="ShowLoginCaptcha" class="form-group">
                  <label for="captchas">{{ $t("store.btn.CAPTCHA") }}</label>
                  <input
                    type="text"
                    v-model="form.captchas"
                    class="form-control"
                    required
                  />
                  <div class="input-group-prepend">
                    <img :src="CaptchasImg" @click="_changeCaptchas" class="signcaptcha_img" />
                  </div>
                </div>

                <div class="form-row container remember">
                  <b-form-checkbox
                    id="checkbox-1"
                    v-model="form.status"
                    name="checkbox-1"
                    value="accepted"
                    unchecked-value="not_accepted"
                  >
                    {{ $t("store.user.rememberme") }}
                  </b-form-checkbox>

                  <div class="form-group forgot_txt">
                    <nuxt-link to="/account/forgot">{{ $t("store.pw.forgot_mark") }}</nuxt-link>
                  </div>
                </div>
                <button type="submit" class="btn btn-submit">
                  {{ $t("store.btn.login") }}
                </button>
                <a v-if="ShowLineLogin" class="lineLogin btn btn-submit mt-3 mb-2" href="/api/Login/Line"><i class="icon icon-line"></i>LINE登入</a>
                <template v-if="DEF_webStyle != 'mkt'">
                  <h4 class="sign-free">{{ $t("store.btn.join_now") }}</h4>
                  <nuxt-link to="/account/signup" class="btn btn-signup">{{ $t("store.btn.sign_up") }}</nuxt-link>
                </template>
              </b-form>
            </div>
          </div>
        </div>
      </div>
      <dialogVerify v-model="form" @memberLogin="MemberLogin"/>
    </template>
  </Layout>
</template>
<script>
  const Layout = require(`~/components/desktop/layouts/${process.env.DEF_webFrame}.vue`).default;
  import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
  import { validationMixin } from "vuelidate";
  import { required } from "vuelidate/lib/validators";
  import { getRemember, setRemember, removeRemember } from "~/utils/remember";
  import pageHead from "~/components/common/pageHead.vue";
  import dialogRule from "~/components/desktop/dialogRule.vue";
  import dialogVerify from "~/components/desktop/dialogVerify.vue";
  export default {
    name: "login",
    middleware: ["checkNoLogin"],
    mixins: [validationMixin],
    components: {
      Layout,
      pageHead,
      dialogRule,
      dialogVerify
    },
    data() {
      return {
        title: this.$t('store.btn.sign'),
        pwInputType: "password",
        pwIconData: "icon icon-eye",
        isSubmit: false,
        form: {
          password: "",
          account: "",
          status: null,
          captchas: "",
        },
      };
    },
    methods: {
      changeIcon(){
        if(this.pwInputType === 'password'){
          this.pwInputType = "text";
          this.pwIconData = 'icon icon-noeye';
        }else{
          this.pwInputType = "password";
          this.pwIconData = 'icon icon-eye';
        }
      },
      login(e) {
        e.preventDefault();

        if (this.isSubmit)
          return;

        this.isSubmit = true;

        if (this.form.status == 'accepted')
          setRemember(this.form.account);
        else
          removeRemember();

        if (this.ImportCheckMobile) {
          this.CheckImportAccount({ account: this.form.account }).then((res) => {
            if (!res)
              this.MemberLogin(this.form);
            else {
              this.isSubmit = false;
              this.$root.$emit("bv::toggle::modal", "modalVerify", "#btnToggle");
            }
          });
        } else {
          this.MemberLogin(this.form);
        }
      },
      MemberLogin(data) {
        if (this.AccountLineCode)
          data.bind_line = this.AccountLineCode;

        this.$auth.loginWith("local", { data }).then((res) => {
          this._changeCaptchas();

          if (res.status != "ok") {
            this._showMsgBox({ title: this.$t("store.tip"), msg: res.msg });
            this.isSubmit = false;
          } else {
            if (this.AccountLineCode)
              this._setLineCode(null);

            this.GetAccountData().then((res) => {
              this.$router.replace({ path: "/" });
            });
          }
        });
      },
      changeLang() {
        this.title = this.$t("store.btn.user_login");
      },
      ...mapActions(["_showMsgBox", "_changeCaptchas"]),
      ...mapActions("account", ["GetAccountData", "CheckImportAccount"]),
      ...mapMutations('login', ['_setLineCode']),
    },
    mounted() {
      this.isSubmit = false;
      this._changeCaptchas();
      this.changeLang();

      let Remember = getRemember();
      if (Remember) {
        this.form.status  = 'accepted';
        this.form.account = Remember;
      }
    },
    watch: {
      "$i18n.locale"(language) {
        this.changeLang();
      },
      "form.status"(status) {
        if (status == 'not_accepted')
         removeRemember();
      },
    },
    computed: {
      DEF_webStyle() {
        return process.env.DEF_webStyle || 'default';
      },
      ...mapState(["CaptchasImg", "WebSetting"]),
      ...mapState('login', ['AccountLineCode']),
      ...mapGetters('webSetting', ['ImportCheckMobile', 'ShowLoginCaptcha', 'ShowLineLogin'])
    },
  };
</script>
